/**
 * NOLAS 2026, (c) Mikaël FOURNY.
 * src/i18n/fr.relanceFiche.ts
 *
 * Messages de l'écran « Relance fiche incomplète » (page Exposants,
 * 2026-09-30). Fusionné dans fr.ts. Aucun tiret cadratin.
 *
 * Mikael - chef de projet - 2026-09-30
 */
export const messagesRelanceFicheFr: Record<string, string> = {
  'relanceFiche.bouton': 'Relance fiche incomplète',
  'relanceFiche.titre': 'Relance « Complétez votre fiche »',
  'relanceFiche.intro':
    'Chaque personne reçoit la liste exacte de ce qui lui manque, avec un lien vers l’écran où le compléter. Décochez une fiche pour l’exclure, ou un élément pour ne pas le réclamer (par exemple « offres » pour un organisme qui ne recrute pas).',
  // Flotte (cirfa) : module emploi coupé, aucune offre n'est réclamée.
  // Mikael - chef de projet - 2026-10-04
  'relanceFiche.intro.sansEmploi':
    'Chaque personne reçoit la liste exacte de ce qui lui manque, avec un lien vers l’écran où le compléter. Décochez une fiche pour l’exclure, ou un élément pour ne pas le réclamer.',
  'relanceFiche.chargement': 'Calcul des fiches incomplètes…',
  'relanceFiche.erreur': 'Impossible de calculer la relance.',
  'relanceFiche.vide': 'Toutes les fiches sont complètes : personne à relancer.',
  'relanceFiche.compteur':
    '{n, plural, =0 {Aucun courriel ne partira} one {# courriel partira} other {# courriels partiront}}',
  'relanceFiche.delai': 'Une même personne n’est pas relancée deux fois en moins de {h} h.',
  'relanceFiche.audience.exhibitor': 'Exposants',
  'relanceFiche.audience.host': 'Animateurs',
  'relanceFiche.audience.recruiter': 'Recruteurs rattachés (photo de badge)',
  'relanceFiche.audience.visitor': 'Visiteurs (photo de badge)',
  'relanceFiche.audience.toutCocher': 'Tout cocher',
  'relanceFiche.audience.toutDecocher': 'Tout décocher',
  'relanceFiche.visiteursFermes':
    'L’envoi aux visiteurs est fermé (réglage exhibitor.fiche_reminder.visitors_enabled). Ils sont affichés pour information.',
  'relanceFiche.inclure': 'Inclure {nom}',
  'relanceFiche.doublon': 'Doublon probable de {autres}',
  'relanceFiche.doublon.email': 'même courriel',
  'relanceFiche.doublon.name': 'nom proche',
  'relanceFiche.relanceLe': 'Relancé le {date}',
  'relanceFiche.dansLeDelai': 'déjà relancé il y a moins de {h} h',
  'relanceFiche.nonRecruteur': 'Ne recrute peut-être pas : décochez « offres » si besoin',
  'relanceFiche.apercu': 'Voir le courriel',
  'relanceFiche.apercu.titre': 'Courriel pour {nom}',
  'relanceFiche.apercu.fermer': 'Fermer l’aperçu',
  'relanceFiche.apercu.erreur': 'Aperçu impossible.',
  'relanceFiche.test': 'M’envoyer ce courriel en test',
  'relanceFiche.test.ok': 'Courriel de test envoyé à {to}.',
  'relanceFiche.test.echec': 'Le serveur de courriel a refusé le test.',
  'relanceFiche.envoyer': 'Envoyer',
  'relanceFiche.confirmer':
    '{n, plural, one {# courriel va partir} other {# courriels vont partir}}, chacun avec la liste de ce qui manque à la personne. Confirmer l’envoi ?',
  'relanceFiche.resultat': '{envoyes, plural, one {# courriel envoyé} other {# courriels envoyés}}, {echecs, plural, =0 {aucun échec} one {# échec} other {# échecs}}.',
  'relanceFiche.envoiErreur': 'L’envoi n’a pas eu lieu.',
  'relanceFiche.journalAbsent':
    'Le journal des relances n’existe pas encore (migration V130) : l’aperçu est consultable, l’envoi est bloqué.',
  'relanceFiche.modeleInactif':
    'Le modèle « Relance, fiche incomplète » est désactivé : l’envoi échouera tant qu’il n’est pas réactivé.',
  'relanceFiche.modifierModele': 'Modifier le message',
  'relanceFiche.plafond': 'Au plus {max} courriels par envoi : décochez-en, puis envoyez en plusieurs fois.',

  'relanceFiche.item.logo': 'Logo',
  'relanceFiche.item.description': 'Présentation',
  'relanceFiche.item.sector': 'Secteur principal',
  'relanceFiche.item.jobs': 'Offres (aucune publiée)',
  'relanceFiche.item.jobs_description': '{n, plural, one {# offre sans description} other {# offres sans description}}',
  'relanceFiche.item.jobs_contract': '{n, plural, one {# offre sans type de contrat} other {# offres sans type de contrat}}',
  'relanceFiche.item.jobs_sector': '{n, plural, one {# offre sans secteur} other {# offres sans secteur}}',
  'relanceFiche.item.workshops_unpublished': '{n, plural, one {# {lexWorkshopBare} non publié{lexWorkshopAgr}} other {# {lexWorkshopPlural} non publié{lexWorkshopAgrPlural}}}',
  'relanceFiche.item.workshops_description': '{n, plural, one {# {lexWorkshopBare} sans description} other {# {lexWorkshopPlural} sans description}}',
  'relanceFiche.item.workshops_audience': '{n, plural, one {# {lexWorkshopBare} sans public visé} other {# {lexWorkshopPlural} sans public visé}}',
  'relanceFiche.item.host_visual': 'Photo ou logo',
  'relanceFiche.item.badge_photo': 'Photo de badge',
};
